import React, { FC } from 'react';

import { DATA_TEST_IDS } from '../../../consts';
import { TEXTS } from '../../../texts';
import PromoOptionsState from '../PromoOptionsState';

const PromoEmptyState: FC = () => (
  <PromoOptionsState
    isCompact
    testId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_EMPTY}>
    {TEXTS.AUDIO_REPORT_PROMOS_EMPTY}
  </PromoOptionsState>
);

export default PromoEmptyState;
